import React from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import {
  HOME_PATH,
  HOW_IT_WORKS_PATH,
  FAUCET_PATH,
  PRIVACY_POLICY_PATH,
  TOS_PATH,
  TRANSACTIONS_PATH,
  TRANSACTION_DETAIL_PATH,
  STATUS_PATH,
  BEAM_PATH,
  LIMITS_PATH,
} from './paths';

import BeamApp from '../BeamApp';

const BeamBridge = React.lazy(() => import('../pages/beam'));
const BeamTransactions = React.lazy(() => import('../pages/beam-transactions'));
const BeamTransactionDetail = React.lazy(() => import('../pages/beam-transaction-detail'));
const BeamStatus = React.lazy(() => import('../pages/beam-status'));
const BeamFaucet = React.lazy(() => import('../pages/beam-faucet'));
const BeamGuide = React.lazy(() => import('../pages/beam-guide'));
const BeamLimits = React.lazy(() => import('../pages/beam-limits'));
const TermsOfService = React.lazy(() => import('../pages/terms-of-service'));
const PrivacyPolicy = React.lazy(() => import('../pages/privacy-policy'));

export const appRouter = createBrowserRouter(
  [
    {
      // BeamApp is the app shell: providers + global styles + <Outlet/>.
      // Every page is AstralBeam now — the legacy cspr-design UI is gone.
      element: <BeamApp />,
      children: [
        {
          path: HOME_PATH,
          element: <BeamBridge />,
        },
        {
          // Old bookmark compatibility: /beam was the reskin's preview route.
          path: BEAM_PATH,
          element: <Navigate to={HOME_PATH} replace />,
        },
        {
          path: TRANSACTIONS_PATH,
          element: <BeamTransactions />,
        },
        {
          path: TRANSACTION_DETAIL_PATH,
          element: <BeamTransactionDetail />,
        },
        {
          path: HOW_IT_WORKS_PATH,
          element: <BeamGuide />,
        },
        {
          path: FAUCET_PATH,
          element: <BeamFaucet />,
        },
        {
          path: TOS_PATH,
          element: <TermsOfService />,
        },
        {
          path: PRIVACY_POLICY_PATH,
          element: <PrivacyPolicy />,
        },
        {
          path: STATUS_PATH,
          element: <BeamStatus />,
        },
        {
          path: LIMITS_PATH,
          element: <BeamLimits />,
        },
        {
          path: '*',
          element: <Navigate to={HOME_PATH} replace />,
        },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL }
);
